import React from "react";

import Collection from "./collection";
import InfiniteScrolling from "../infinite-scrolling";
import FetchCollections from "./fetch-collections";
import Modal from "../../../containers/modal";

const Collections = ({ collections, loadMoreCollections }) => {
    return (
        <ol className="col-xs-12">
            {
                <InfiniteScrolling
                    loadMore={loadMoreCollections}
                    elements={
                        collections &&
                        collections.map(collection => (
                            <li
                                id={`collection-${collection.id}`}
                                className="collection clearfix"
                                key={collection.id}
                            >
                                <Collection collection={collection} />
                            </li>
                        ))
                    }
                />
            }
        </ol>
    );
};

const InfiniteCollections = ({
    args: { userId, signedInUserId, userUsername }
}) => {
    return (
        <div>
            <section className="profile-detail">
                <div className="container row">
                    <header className="clearfix col-xs-12">
                        <h3 className="ui_collections columns eight">
                            Collections
                        </h3>
                        {userId === signedInUserId ? (
                            <a
                                className="back-link columns four"
                                href="/dashboard"
                            >
                                Dashboard
                            </a>
                        ) : (
                            <a
                                className="back-link columns four"
                                href={"/" + userUsername}
                            >
                                View profile
                            </a>
                        )}
                    </header>
                    <FetchCollections
                        iconLimit={10}
                        collectionLimit={20}
                        userId={userId}
                        offset={0}
                    >
                        <Collections />
                    </FetchCollections>
                </div>
            </section>
            <Modal />
        </div>
    );
};

export default InfiniteCollections;
